import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Card,
  CardContent,
  CardActions,
  Button,
  Box,
  IconButton
} from '@mui/material';
import {
  People as PeopleIcon,
  Settings as SettingsIcon,
  Assessment as AssessmentIcon,
  Build as BuildIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

function AdminDashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const adminModules = [
    {
      title: 'Gestión de Usuarios',
      description: 'Administra usuarios, roles y permisos',
      icon: <PeopleIcon style={{ fontSize: 48 }} />,
      color: '#4CAF50',
      path: '/admin/usuarios'
    },
    {
      title: 'Configuración del Sistema',
      description: 'Ajustes generales y configuración',
      icon: <SettingsIcon style={{ fontSize: 48 }} />,
      color: '#2196F3',
      path: '/configuracion'
    },
    {
      title: 'Reportes',
      description: 'Estadísticas y reportes del sistema',
      icon: <AssessmentIcon style={{ fontSize: 48 }} />,
      color: '#FF9800',
      path: '#',
      disabled: true
    },
    {
      title: 'Mantenimiento',
      description: 'Herramientas de mantenimiento',
      icon: <BuildIcon style={{ fontSize: 48 }} />,
      color: '#9C27B0',
      path: '#',
      disabled: true
    }
  ];

  const handleModuleClick = (path, disabled) => {
    if (!disabled && path !== '#') {
      navigate(path);
    }
  };

  return (
    <Container maxWidth="lg" style={{ marginTop: '2rem' }}>
      {/* Header */}
      <Box mb={4}>
        <Box display="flex" alignItems="center" mb={2}>
          <IconButton onClick={() => navigate('/')} style={{ marginRight: '1rem' }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1">
            Panel de Administración
          </Typography>
        </Box>
        <Typography variant="body1" color="textSecondary">
          Bienvenido, {user.nombre || 'Administrador'}
        </Typography>
      </Box>

      {/* Admin Modules Grid */}
      <Grid container spacing={3}>
        {adminModules.map((module, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              style={{
                height: '100%',
                cursor: module.disabled ? 'not-allowed' : 'pointer',
                opacity: module.disabled ? 0.6 : 1,
                transition: 'transform 0.2s',
              }}
              onMouseOver={(e) => {
                if (!module.disabled) {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
              onClick={() => handleModuleClick(module.path, module.disabled)}
            >
              <CardContent style={{ textAlign: 'center', padding: '2rem' }}>
                <Box style={{ color: module.color, marginBottom: '1rem' }}>
                  {module.icon}
                </Box>
                <Typography variant="h6" component="h2" gutterBottom>
                  {module.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {module.description}
                </Typography>
                {module.disabled && (
                  <Typography
                    variant="caption"
                    style={{
                      display: 'block',
                      marginTop: '0.5rem',
                      color: '#f44336'
                    }}
                  >
                    Próximamente
                  </Typography>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Stats Section */}
      <Box mt={4}>
        <Typography variant="h5" component="h2" gutterBottom>
          Estadísticas Rápidas
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={3}>
            <Paper style={{ padding: '1.5rem', textAlign: 'center' }}>
              <Typography variant="h4" color="primary">
                0
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Usuarios Activos
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper style={{ padding: '1.5rem', textAlign: 'center' }}>
              <Typography variant="h4" color="primary">
                0
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Presupuestos
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper style={{ padding: '1.5rem', textAlign: 'center' }}>
              <Typography variant="h4" color="primary">
                0
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Materiales
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Paper style={{ padding: '1.5rem', textAlign: 'center' }}>
              <Typography variant="h4" color="primary">
                0
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Precios Unitarios
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      {/* Quick Actions */}
      <Box mt={4} mb={4}>
        <Typography variant="h5" component="h2" gutterBottom>
          Acciones Rápidas
        </Typography>
        <Grid container spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/admin/usuarios')}
            >
              Gestionar Usuarios
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => navigate('/')}
            >
              Ir al Dashboard Principal
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                navigate('/login');
              }}
            >
              Cerrar Sesión
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default AdminDashboard;